/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 0 auto}.progress[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:5px;z-index:1}"];
export { styles as styles };
